import request from './request'

export function listWorkstation(data) {
  return request.post('/mes/workstations/list', data)
}
export function selectWorkstation() {
  return request.get('/mes/workstations/select')
}
export function getWorkstation(id) {
  return request.get('/mes/workstations/' + id)
}
export function saveWorkstation(data) {
  return request.post('/mes/workstations', data)
}
export function updateWorkstation(data) {
  return request.post('/mes/workstations/update', data)
}
export function deleteWorkstation(ids) {
  return request.post('/mes/workstations/delete', ids)
}
